import React from 'react';
import styled from 'styled-components';

import { Paragraph } from '@repo/ui/components/typography/Content';
import Buttons from '@repo/ui/components/buttons';
import { Trans, useTranslation } from 'react-i18next';
import { handleSocialConnect } from '../../../utils/SocialConnect';

const Container = styled.div`
  padding: ${(props) => props.theme.margins.xs};
  text-align: center;
  background-color: ${(props) => props.theme.brandColors.statusColors.warning};

  & p {
    margin: 0 !important;
  }

  & button {
    padding: 6.6px !important;
  }
`;

export default function RequireSsoHeaderNotice({ user, location }) {
  const { t } = useTranslation(['common']);

  return (
    <Container>
      <Paragraph inverse>
        <Trans t={t} i18nKey="common:alerts.headerRequireSso">
          <strong>Heads up!</strong> Your employer requires that you have your workplace SSO
          connected in order to access team areas.{' '}
          <Buttons.Secondary inverse onClick={() => handleSocialConnect('sso-connect', location)}>
            Connect with Workplace SSO
          </Buttons.Secondary>
        </Trans>
      </Paragraph>
    </Container>
  );
}
